import './CtaBlock.scss'

import React from 'react'
import {LinkType, WysiwygType} from '../../types'
import {Mod, style} from '../../util/style'
import {HeadingMods, Theme} from '../../views/Theme'
import {ButtonMods} from '../../views/ui/Button'
import {Block} from './Blocks'

const styles = style('ctablock')

export type CtaBlockType = {
	title?: string
	text?: WysiwygType
	button?: LinkType
	bgcolor?: 'greylight' | 'green'
	mods?: Array<'border' | 'markedtitle' | 'overflowbtn'>
}

export const CtaBlock: React.FC<
	CtaBlockType & {container?: boolean; sidebar?: boolean}
> = ({container, sidebar, title, text, button, bgcolor, mods}) => {
	if (!title && !text && !button) return null

	return (
		<Block
			className={styles().mod(bgcolor).mod(mods)}
			container={container}
			sidebar={sidebar}
		>
			<div className={styles('block').mod(bgcolor).mod(mods)}>
				{title && (
					<Theme.H3
						className={styles('block-title')}
						mod={switchTitleMod(bgcolor, mods)}
					>
						{title}
					</Theme.H3>
				)}
				{text && (
					<div className={styles('block-text')}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				)}
				{button?.url && (
					<div className={styles('block-button')}>
						<Theme.Button to={button.url} mod={switchButtonMod(bgcolor)}>
							{button.description || button.title}
						</Theme.Button>
					</div>
				)}
			</div>
		</Block>
	)
}

function switchTitleMod(bgcolor, mods): Mod<HeadingMods> {
	if (!mods) return []

	switch (true) {
		case mods.includes('markedtitle') && !bgcolor:
		case mods.includes('border') && mods.includes('markedtitle') && !bgcolor:
			return ['white', 'marked', 'slantleft']
		case mods.includes('border') && !bgcolor:
			return ['green']
		case mods.includes('markedtitle') && bgcolor !== null:
			return ['green', 'marked', 'slantleft']
		case mods.includes('markedtitle'):
			return ['marked', 'slantleft']
		case bgcolor === 'green':
			return ['white']
		default:
			return []
	}
}

function switchButtonMod(bgcolor): Mod<ButtonMods> {
	switch (true) {
		case bgcolor === 'green':
			return ['outline', 'boldtext']
		default:
			return ['boldtext']
	}
}
